import { Component, ViewEncapsulation, ViewChild, ElementRef, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { Router } from '@angular/router';
import { CandidateReleaseFormService } from '../services/employment-application.service';
import { ICRFPersonalDetails, CRFPersonalDetails, CRFEducation, IPreferenceList, PreferenceList } from './employment-application';
import { isUndefined, isNull } from 'util';
import { FileUploaderComponent } from './file-uploader/file-uploader.component'
import { ToastrService } from 'ngx-toastr';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';

@Component({
    selector: 'app-wizard',
    templateUrl: './employment-application.component.html',
    styleUrls: ['./employment-application.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [CandidateReleaseFormService],
    // host: {
    //     '(document:click)': 'onClick($event)',
    //   },
})
export class CandidateReleaseFormComponent implements OnInit {
    ngOnInit() {
        // this.validateInputs();
    }
    // myEvent($event) {
    //     debugger
    //     console.log(1, $event);
    // }
    public router: Router;
    public candidateReleaseForm: ICRFPersonalDetails;
    public preferenceList: IPreferenceList;
    private notificationTitle: string = '';
    private errorMessage: string = '';
    private successMessage: string = '';
    public loading = false;
    public steps: any[];
    public confirmed: boolean;
    public mobileRegex = /^((?!(0))[0-9]*)$/i;
    public felonyFile: File;
    public today = new Date();
    public minDate = { year: this.today.getFullYear() - 70, month: 1, day: 1 };
    public maxDate = { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() };
    public employMinDate = { year: this.today.getFullYear() - 40, month: 1, day: 1 };
    public employMaxDate = { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() };
    public militaryMinDate = { year: this.today.getFullYear() - 50, month: 1, day: 1 };
    public militaryMaxDate = { year: this.today.getFullYear() , month: this.today.getMonth() + 1, day: this.today.getDate() };
    private SSN: string = '';
    private Authorization = { SSN: '' };
    public formJobPreferencesError: string = ''; preference1Error = ''; preference2Error = ''; preference3Error = '';
    @ViewChild(FileUploaderComponent) child;
    public firstControlModel: number[];
    public weekDays: IMultiSelectOption[] = [
        { id: 'Monday', name: 'Monday' },
        { id: 'Tuesday', name: 'Tuesday' },
        { id: 'Wednesday', name: 'Wednesday' },
        { id: 'Thursday', name: 'Thursday' },
        { id: 'Friday', name: 'Friday' }
    ];
    public daysCantWork = [];

    constructor(router: Router, private formBuilder: FormBuilder, private _candidateReleaseFormService: CandidateReleaseFormService, private toastr: ToastrService, private _eref: ElementRef) {
        this.candidateReleaseForm = new CRFPersonalDetails();
        this.preferenceList = new PreferenceList();
        // this.router = router;

        this.steps = [
            { name: 'Personal Information', icon: 'fa-lock', active: true, valid: false, hasError: false },
            { name: 'Education Information', icon: 'fa-user', active: false, valid: false, hasError: false },
            { name: 'Employment History / Military Service', icon: 'fa-user', active: false, valid: false, hasError: false },
            { name: 'References Information and Availability', icon: 'fa-check-square-o', active: false, valid: false, hasError: false },
            { name: 'Job Preferences', icon: 'fa-check-square-o', active: false, valid: false, hasError: false },
            { name: 'Candidate Release Authorization', icon: 'fa-check-square-o', active: false, valid: false, hasError: false, show: true },
            { name: 'Form Overview', icon: 'fa-check-square-o', active: false, valid: false, hasError: false }
        ]
    }

    private convertToDate(date: any) {
        if (isUndefined(date) || isNull(date))
            return date;
        return new Date(date.year, date.month - 1, date.day);
    }

    next(event: Event) {
        var element;
        if (this.steps[this.steps.length - 1].active)
            return false;
        this.steps.filter(x => x.name == 'Candidate Release Authorization')[0].show = JSON.parse(this.candidateReleaseForm.BelowOr18Years.toString());
        this.steps.some(function (step, index, steps) {
            if (index < steps.length - 1) {
                if (step.active) {
                    if (step.name == 'Personal Information') {
                        // var form = document.getElementById('PersonalInformation');
                        // if (true) {
                        step.active = false;
                        step.valid = true;
                        steps[index + 1].active = true;
                        var setTime = setTimeout(function (e) {
                            jQuery("form[id='EducationInformation'] *:input[type!=hidden]:first").focus();
                            clearTimeout(setTime);
                        }, 10);
                        return true;
                    }
                    else if (step.name == 'Education Information') {
                        // var form = document.getElementById('EducationInformation');
                        step.active = false;
                        step.valid = true;
                        steps[index + 1].active = true;
                        var setTime = setTimeout(function (e) {
                            jQuery("form[id='EmploymentInformation'] *:input[type!=hidden]:first").focus();
                            clearTimeout(setTime);
                        }, 10);
                        return true;
                    }
                    else if (step.name == 'Employment History / Military Service') {
                        // var form = document.getElementById('EmploymentInformation');
                        step.active = false;
                        step.valid = true;
                        steps[index + 1].active = true;
                        var setTime = setTimeout(function (e) {
                            jQuery("form[id='ReferencesInformation'] *:input[type!=hidden]:first").focus();
                            clearTimeout(setTime);
                        }, 10);
                        return true;
                    }
                    else if (step.name == 'References Information and Availability') {
                        // var form = document.getElementById('ReferencesInformation');
                        step.active = false;
                        step.valid = true;
                        steps[index + 1].active = true;
                        var setTime = setTimeout(function (e) {
                            jQuery("form[id='JobPreferences'] *:input[type!=hidden]:first").focus();
                            clearTimeout(setTime);
                        }, 10);
                        return true;
                    }
                    else if (step.name == 'Job Preferences') {
                        // var form = document.getElementById('JobPreferences');
                        step.active = false;
                        step.valid = true;
                        if (steps[index + 1].show) {
                            steps[index + 1].active = true;
                            var setTime = setTimeout(function (e) {
                                jQuery("form[id='CandidateReleaseAuthorization'] *:input[type!=hidden]:first").focus();
                                clearTimeout(setTime);
                            }, 10);
                        }
                        else
                            steps[index + 2].active = true;
                        return true;
                    }
                    else if (step.name == 'Candidate Release Authorization') {
                        // var form = document.getElementById('CandidateReleaseAuthorization');
                        step.active = false;
                        step.valid = true;
                        steps[index + 1].active = true;
                        jQuery('html, body').animate({
                            scrollTop: 1
                        }, 1);
                        return true;
                    }
                    else if (step.name == 'Form Overview') {
                        // var form = document.getElementById('FormOverview');
                        step.active = false;
                        step.valid = true;
                        steps[index + 1].active = true;
                        return true;
                    }
                }
            }
        });
        // (function (elem) {
        //     debugger
        //     var setTime = setTimeout(function (e) {
        //         debugger
        //         // jQuery("form[id='EducationInformation'] *:input[type!=hidden]:first").focus();
        //         clearTimeout(setTime);
        //     }, 10);
        // })(element);
    }

    public prev() {
        if (this.steps[0].active)
            return false;
        this.steps.some(function (step, index, steps) {
            if (index != 0) {
                if (step.active) {
                    step.active = false;
                    if (steps[index - 1].show === undefined || steps[index - 1].show)
                        steps[index - 1].active = true;
                    else
                        steps[index - 2].active = true;
                    return true;
                }
            }
        });
    }

    public confirm() {
        this.steps.forEach(step => step.valid = true);
        this.confirmed = true;
    }

    public submitForm(values: Event): void {
        this.loading = true;
        this.candidateReleaseForm.BirthDay = this.convertToDate(this.candidateReleaseForm.BirthDay);
        this.candidateReleaseForm.CRFAuthorizations.DOB = this.convertToDate(this.candidateReleaseForm.CRFAuthorizations.DOB);
        this.candidateReleaseForm.CRFAvailabilities.FirstDateAvailable = this.convertToDate(this.candidateReleaseForm.CRFAvailabilities.FirstDateAvailable);
        this.candidateReleaseForm.CRFAvailabilities.LastDateAvailable = this.convertToDate(this.candidateReleaseForm.CRFAvailabilities.LastDateAvailable);
        this.candidateReleaseForm.CRFEmploymentHistories[0].Date = this.convertToDate(this.candidateReleaseForm.CRFEmploymentHistories[0].Date);
        this.candidateReleaseForm.CRFEmploymentHistories[1].Date = this.convertToDate(this.candidateReleaseForm.CRFEmploymentHistories[1].Date);
        this.candidateReleaseForm.CRFMilitaryServices.DateEntered = this.convertToDate(this.candidateReleaseForm.CRFMilitaryServices.DateEntered);
        this.felonyFile = this.child === undefined || this.child.uploadFile === undefined ?
            this.felonyFile : this.child.uploadFile;
        this.candidateReleaseForm.FelonyFile = this.felonyFile !== undefined ?
            this.child.uploadFile.name.replace(/\.[^/.]+$/, "") + '_' + new Date().valueOf() + '.' + this.child.uploadFile.name.split('.').pop() : '';
        this.candidateReleaseForm.Phone = this.removeMask(this.candidateReleaseForm.Phone);
        this.candidateReleaseForm.CellPhone = this.removeMask(this.candidateReleaseForm.CellPhone);
        this.candidateReleaseForm.EmergencyPhone = this.removeMask(this.candidateReleaseForm.EmergencyPhone);
        this.candidateReleaseForm.EmergencyAltPhone = this.removeMask(this.candidateReleaseForm.EmergencyAltPhone);
        this.candidateReleaseForm.CRFEmploymentHistories[0].Phone = this.removeMask(this.candidateReleaseForm.CRFEmploymentHistories[0].Phone);
        this.candidateReleaseForm.CRFEmploymentHistories[1].Phone = this.removeMask(this.candidateReleaseForm.CRFEmploymentHistories[1].Phone);
        this.candidateReleaseForm.CRFReferenceLists[0].Phone = this.removeMask(this.candidateReleaseForm.CRFReferenceLists[0].Phone);
        this.candidateReleaseForm.CRFReferenceLists[1].Phone = this.removeMask(this.candidateReleaseForm.CRFReferenceLists[1].Phone);
        this.candidateReleaseForm.SSN = this.removeMask(this.SSN);
        this.candidateReleaseForm.CRFAuthorizations.SSN = this.removeMask(this.Authorization.SSN);
        this.candidateReleaseForm.CRFAvailabilities.DaysCantWork = this.daysCantWork.join();
        this._candidateReleaseFormService.PostCandidateReleaseForm(this.candidateReleaseForm, this.felonyFile, this.candidateReleaseForm.FelonyFile).subscribe(

            data => {
                if (data != null) {
                    this.errorMessage = '';
                    this.successMessage = <any>data;
                    this.notificationTitle = <any>data;
                    this.loading = false;
                    this.candidateReleaseForm = new CRFPersonalDetails();
                    // localStorage.setItem('currentUser', JSON.stringify(this.user));
                    // this.router.navigate(['pages/schedule']);
                }
                else {
                    this.loading = false;
                    // this.notificationTitle = 'Invalid Login Attempt.';
                    // this.toastr.error(this.notificationTitle);
                }
            },
            error => {
                this.loading = false;
                this.errorMessage = <any>error;
                this.notificationTitle = this.errorMessage;
                this.toastr.success(this.notificationTitle);
            },
            // () => {debugger
            //     this.loading = false;
            //     this.notificationTitle = 'Form submitted successfully.';
            //     // this.toastr.success(this.notificationTitle);
            // }
        );
    }

    public maskMobileNumber(value) {
        const x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        return !x[2] ? x[1] : `(${x[1]}) ${x[2]}${x[3] ? `-${x[3]}` : ''}`;
    }

    public formatMobile(event: any) {
        if (event.target != null)
            event.target.value = this.maskMobileNumber(event.target.value.replace(/[^0-9]/g, ''));
        else
            return this.maskMobileNumber(event.replace(/[^0-9]/g, ''));
    }

    public formatSSN(event: any) {
        if (event.which < 48 || event.which > 57) {
            event.preventDefault();
        }
        if (event.target != null)
            event.target.value = this.maskSSN(event.target.value.replace(/[^0-9]/g, ''));
        else
            return this.maskSSN(event.replace(/[^0-9]/g, ''));
    }

    public maskSSN(value) {
        // value += '00000000';
        const x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,2})(\d{0,4})/);
        return !x[2] ? x[1] : `${x[1]}-${x[2]}${x[3] ? `-${x[3]}` : ''}`;
    }

    public secureSSN(event: any) {
        if (event != undefined)
            if (event.target != undefined) {
                this.SSN = event.target.value;
                var x = event.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,2})(\d{0,4})/);
                event.target.value = !x[2] ? x[1] : `XXX-XX${x[3] ? `-${x[3]}` : ''}`
            }
            else {
                var x = event.replace(/\D/g, '').match(/(\d{0,3})(\d{0,2})(\d{0,4})/);
                return !x[2] ? x[1] : `XXX-XX${x[3] ? `-${x[3]}` : ''}`
            }
    }

    public secureAuthSSN(event: any) {
        if (event.target != null) {
            this.Authorization.SSN = event.target.value;
            var x = event.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,2})(\d{0,4})/);
            event.target.value = !x[2] ? x[1] : `XXX-XX${x[3] ? `-${x[3]}` : ''}`
        }
        else {
            var x = event.replace(/\D/g, '').match(/(\d{0,3})(\d{0,2})(\d{0,4})/);
            return !x[2] ? x[1] : `XXX-XX${x[3] ? `-${x[3]}` : ''}`
        }
    }

    public resolveSSN(event: any) {
        event.target.value = this.SSN;
    }

    public resolveAuthSSN(event: any) {
        event.target.value = this.Authorization.SSN;
    }

    public removeMask(value) {
        if (value !== undefined)
            return value.replace(' ', '').replace('(', '').replace(')', '').replace('-', '');
        else
            return value;
    }
    public validateJobPreferences() {
        // var cnt = 0;
        // jQuery('.valid').each(function (e) {
        //     if (parseInt(this.value) > 0)
        //         cnt++;
        // });
        // if (cnt > 3) {
        //     this.formJobPreferencesError = 'Up to 3 choices can be selected';
        //     event.target.value = 0;
        // }
        // else {
        //     this.formJobPreferencesError = '';
        // }
        if (this.preference1Error != '' || this.preference2Error != '' || this.preference3Error != '') {
            this.scrollToError();
            return false;
        }
        else
            return true;
    }
    public scrollToError() {
        var setTime = setTimeout(function () {
            if (jQuery(".err").length > 0) {
                jQuery('html, body').animate({
                    scrollTop: jQuery(".err").offset().top - 110
                }, 100);
                clearTimeout(setTime);
            }
        }, 1);
    }

    public validateForm(form: any) {
        if (form.submitted) {
            if (!form.valid) {
                this.scrollToError();
                return false;
            }
            else
                return true;
        }
        else
            return false;

    }

    public onChangePreference1(event: any) {
        if (event.target.value.trim() != '' && (event.target.value === this.candidateReleaseForm.CRFJobPreferences.Preference2
            || event.target.value === this.candidateReleaseForm.CRFJobPreferences.Preference3))
            this.preference1Error = 'This preference already selected';
        else
            this.preference1Error = '';
    }

    public onChangePreference2(event: any) {
        if (event.target.value.trim() != '' && (event.target.value === this.candidateReleaseForm.CRFJobPreferences.Preference1
            || event.target.value === this.candidateReleaseForm.CRFJobPreferences.Preference3))
            this.preference2Error = 'This preference already selected';
        else
            this.preference2Error = '';
    }

    public onChangePreference3(event: any) {
        if (event.target.value.trim() != '' && (event.target.value === this.candidateReleaseForm.CRFJobPreferences.Preference1
            || event.target.value === this.candidateReleaseForm.CRFJobPreferences.Preference2))
            this.preference3Error = 'This preference already selected';
        else
            this.preference3Error = '';
    }

    public validateInputs(event: any) {
        var regex = /^[a-zA-Z ]*$/;
        var str = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!regex.test(str)) {
            event.preventDefault();
        }
    }

    public validateInputsalphanumeric(event: any) {
        var regex = /^[a-zA-Z0-9]*$/;
        var str = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!regex.test(str)) {
            event.preventDefault();
        }
    }

    public validateDigit(event: any) {
        if (event.which < 48 || event.which > 57) {
            event.preventDefault();
        }
    }

    ngAfterViewInit() {
        document.getElementById('preloader').classList.add('hide');
    }
}


// WEBPACK FOOTER //
// E:/sachin/Project/Masterly_Solutions/Project_HRMS/Hrms_Developer/hrms/Peerless.HRMS.WebUI.EmployeePortal/src/app/pages/employment-application/employment-application.component.ts